// src/components/products/sensaphone/SensaphoneOverview.jsx
import React from "react";
import { cellTextForRow } from "./sensaphoneTableCellText";

const SensaphoneOverview = ({ title, rows, safeText }) => {
  if (!title) return null;

  return (
    <div className="mb-12 md:mb-16">
      <div className="product-panel-elevated rounded-3xl shadow-2xl overflow-hidden">
        {/* Overview Title Bar */}
        <div className="product-panel-header">
          <h2>
            {safeText(title)}
          </h2>
        </div>

        {/* Overview Table */}
        <div className="p-6 sm:p-8 lg:p-10">
          {rows && rows.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <tbody>
                  {rows.map((row, index) => {
                    const type = cellTextForRow(row.type, safeText);
                    const text = cellTextForRow(row.text, safeText);

                    return (
                      <tr
                        key={row.id || index}
                        className={`border-b product-table-row ${
                          index % 2 === 0
                            ? "product-stripe-even"
                            : "bg-white/85"
                        }`}
                      >
                        <td className="product-detail-content px-4 py-3 text-sm font-semibold product-table-type sm:px-6 sm:py-4 sm:text-base w-1/3 align-top whitespace-pre-line">
                          {type}
                        </td>
                        <td className="product-detail-content px-4 py-3 text-sm text-gray-700 sm:px-6 sm:py-4 sm:text-base w-2/3 align-top whitespace-pre-line">
                          {text}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              <p>No overview data available.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SensaphoneOverview;





